import { cookieProfil } from "./cookieProfil";

export const eventNeed = () => {
    const blockTargets = document.querySelector('.home .block.targets');
    if (blockTargets) {
        const buttons = blockTargets.querySelectorAll('ul.items .item') as NodeListOf<HTMLElement>;
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                // Set cookie profil.
                cookieProfil.setCookie('profil', button?.textContent?.trim() || 'na', 30);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'Besoin',
                    'profil': button?.textContent?.trim() || 'na'
                });
            });
        });
    }
}
